import "./DesignCards.css";
import DesignCard from "./DesignCard/DesignCard";

const DesignCards = ({ designData, sortOrder, pageSize, loadIndex }) => {
  let sortedGrid = [];
  if (designData?.data) {
    sortedGrid = designData?.data?.slice(0, loadIndex * pageSize)?.sort((a, b) => {
      if (sortOrder === "mostRecent") {
        return new Date(b.createdAt) - new Date(a.createdAt);
      } else if (sortOrder === "mostVoted") {
        return b?.likes?.length - a?.likes?.length;
      } else if (sortOrder === "leastVoted") {
        return a?.likes?.length - b?.likes?.length;
      }
    });
  } 

  return (
    <div className="grid-components-wrapper">
      {sortedGrid?.map((gridElement, index) => (
        <div className="card_wrapper_component" key={gridElement?.id}>
            <DesignCard
              index={index}
              key={gridElement?.id}
              designId={gridElement?.id}
              pinId={gridElement?.pin_id}
              title={gridElement?.title}
              thumbnail={gridElement?.thumbnail}
              likes={gridElement?.likes}
              createdAt={gridElement?.createdAt}
              cityName={designData?.cityName}
              pinName={designData?.pinName}
              isAdmin={false}
              sortOrder={sortOrder}
            /> 
        </div>
        ))}
    </div>
  );
};

export default DesignCards;
